'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'motion/react';
import { cn } from '@/lib/utils';
export function TriggerIcon({ isConnecting = false, isConnected = false, hasError = false, }) {
    // Waveform bars animacija
    const barVariants = {
        idle: (i) => ({
            scaleY: [1, 1.5, 1],
            transition: {
                duration: 1.2,
                repeat: Infinity,
                delay: i * 0.15,
                ease: 'easeInOut',
            },
        }),
        connecting: {
            scaleY: [0.5, 1, 0.5],
            transition: {
                duration: 0.8,
                repeat: Infinity,
                ease: 'easeInOut',
            },
        },
        connected: {
            scaleY: [1, 1.8, 1],
            transition: {
                duration: 0.6,
                repeat: Infinity,
                ease: 'easeInOut',
            },
        },
        error: {
            scaleY: 1,
            opacity: 0.5,
        },
    };
    const state = hasError
        ? 'error'
        : isConnected
            ? 'connected'
            : isConnecting
                ? 'connecting'
                : 'idle';
    return (_jsx("svg", { viewBox: "0 0 24 24", className: cn('h-6 w-6', !hasError && 'light:text-[#99CDFF] text-white'), fill: "none", children: [0, 1, 2, 3, 4].map((i) => (_jsx(motion.rect, { x: 3 + i * 4.5, y: 8, width: 2, height: 8, rx: 1, className: cn(hasError ? 'fill-destructive-foreground' : 'fill-current', 'origin-bottom'), custom: i, variants: barVariants, animate: state }, i))) }));
}
